module.exports = __webpack_public_path__ + "imgcvh/hero-2.d44b603b.jpg";